import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PatrimonioMueblesModalComponent } from '../modales/patrimonio/patrimonio-muebles-modal/patrimonio-muebles-modal.component';
import { PatrimonioInmueblesModalComponent } from '../modales/patrimonio/patrimonio-inmuebles-modal/patrimonio-inmuebles-modal.component';
import { PatrimonioAccionesModalComponent } from '../modales/patrimonio/patrimonio-acciones-modal/patrimonio-acciones-modal.component';
import { PatrimonioDisponibleModalComponent } from '../modales/patrimonio/patrimonio-disponible-modal/patrimonio-disponible-modal.component';
import { PatrimonioInventarioModalComponent } from '../modales/patrimonio/patrimonio-inventario-modal/patrimonio-inventario-modal.component';
import { PatrimonioActivosOmitidosModalComponent } from '../modales/patrimonio/patrimonio-activos-omitidos-modal/patrimonio-activos-omitidos-modal.component';
import { PatrimonioActivosExtranjeraModalComponent } from '../modales/patrimonio/patrimonio-activos-extranjera-modal/patrimonio-activos-extranjera-modal.component';
import { PatrimonioOtrosActivosModalComponent } from '../modales/patrimonio/patrimonio-otros-activos-modal/patrimonio-otros-activos-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DTasaCambioCompleto } from '@dian-api/renta210v18';
import { DialogoConfirmacionComponent } from '../../../table-items/dialogo-confirmacion/dialogo-confirmacion.component';
import { ComponentFactoryService } from '../../../../services/component-factory.service';
import { RentasLiquidasGravablesComponent } from '../modales/impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component';

const questions: Question[] = [
  { //P1
    question: '¿Tuvo bienes muebles (vehículos, electrodomésticos y otros)? ',
    field: 'cs_id_151', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_152"
  },
  { //P2
    question: '¿Tuvo bienes inmuebles (casas, lotes, fincas, apartamentos, parcelas, parqueaderos, locales y oficinas)?',
    field: 'cs_id_153', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_154"
  },
  { //P3
    question: '¿Tuvo acciones o cuotas partes en sociedades comerciales?',
    field: 'cs_id_155', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_156"
  },
  { //P4
    question: '¿Tuvo ahorros en, dinero en efectivo, cuentas bancarias, depósitos de bajo monto (billeteras virtuales), CDTS, fondos de empleados, fondos de cesantías, fondos de pensiones voluntarias, cooperativas y otras entidades financieras?',
    field: 'cs_id_159', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_160"
  },
  { //P5
    question: '¿Su negocio como persona natural tuvo inventarios? No incluir inventarios como persona jurídica.',
    field: 'cs_id_157', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_158"
  },
  { //P6
    question: '¿Tuvo otros activos en moneda nacional? ',
    field: 'cs_id_161', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_162"
  },
  { //P7
    question: '¿Tuvo activos en moneda extranjera?',
    field: 'cs_id_163', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_164"
  },
  { //P8
    question: '¿Tiene algún activo que no haya declarado en periodos anteriores?',
    field: 'cs_id_165', show: false, nextIfValue: "1", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_166"
  }
];

@Component({
  selector: 'app-patrimonio',
  templateUrl: './patrimonio.component.html',
  styleUrls: ['./patrimonio.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class PatrimonioComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Input('tablaArt73') tablaArt73: any;
  @Input('listaMoneda') listaMoneda: any;
  @Input('listaModoAdquision') listaModoAdquision: any;
  @Input('listaOrigenInformacion') listaOrigenInformacion: any;
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('getTRM') getTRM: EventEmitter<DTasaCambioCompleto> = new EventEmitter<DTasaCambioCompleto>();

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _componentFactory: ComponentFactoryService
  ) {
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.initializeSiTieneSugerida();
  }

  validateQuestions(id: number) {
    //console.log(id);
  }

  
  questionHasSugerida(index: number) {
    return questions[index].hasSuggested == "1";
  }
  /**
   * Inicializa las respuestas en Sí si la sección tiene sugerida
   */
  initializeSiTieneSugerida(){
    for (let numPregunta = 0; numPregunta < questions.length; numPregunta++) {
      if (this.questionHasSugerida(numPregunta) && questions[numPregunta].resp!="0") {
        questions[numPregunta].resp='1';
        this.model.doc.cuerpo[questions[numPregunta].field]="1";
      }
    }
  }

  initilizeQuestionsDesdeModelo(model) {
    for (let i = 0; i < questions.length; i++) {
      questions[i].resp = model.doc.cuerpo[questions[i].field];
      questions[i].isCompleted = this.validateModalCompleted(i);
      if (questions[i].isCompleted || model.doc.cuerpo[questions[i].field] == "1") { questions[i].show = true; }
      this.checkNextQuestion(i);
    }
  }

  openModal(indexQuestionModal: number) {
    const configSinSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    const configSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: {
        model: this.model
      }
    }
    let config;
    if(this.questionHasSugerida(indexQuestionModal)){
      config = configSugerida;
    }else{
      config = configSinSugerida;
    }
    switch (indexQuestionModal) {
      case 0://¿Tuve bienes muebles? (vehículos, enseres de uso doméstico y otros). Incluya los adquiridos por leasing.
        let dialog0 = this.dialog.open(PatrimonioMueblesModalComponent, config);
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1://¿Tuve bienes inmuebles? (casas, lotes, fincas, apartamentos, parcelas, parqueaderos, locales, oficinas y otros). Incluya los adquiridos por leasing.
        let dialog1 = this.dialog.open(PatrimonioInmueblesModalComponent, config);
        dialog1.componentInstance.tablaArt73 = this.tablaArt73;
        dialog1.componentInstance.listaModoAdquisicion = this.listaModoAdquision;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 2://¿Tuve acciones o cuotas partes en sociedades?
        let dialog2 = this.dialog.open(PatrimonioAccionesModalComponent, config);
        dialog2.componentInstance.tablaArt73 = this.tablaArt73;
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 3://A diciembre 31 ¿Tuve ahorros en, dinero en efectivo, cuentas bancarias, depósitos de bajo monto (billeteras virtuales), CDTS, fondos de empleados, fondos de cesantías, fondos de pensiones voluntarias, cooperativas y otras entidades financieras?
        let dialog3 = this.dialog.open(PatrimonioDisponibleModalComponent, config);
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 4://A diciembre 31 ¿Como persona natural tuve inventarios?
        let dialog4 = this.dialog.open(PatrimonioInventarioModalComponent, config);
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog4.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 5://A diciembre 31 ¿Tuve activos en moneda nacional diferentes de los anteriores?
        let dialog5 = this.dialog.open(PatrimonioOtrosActivosModalComponent, config);
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 6://A diciembre 31 ¿Tuve activos en moneda extranjera?
        let dialog6 = this.dialog.open(PatrimonioActivosExtranjeraModalComponent, config);
        dialog6.componentInstance.listaMoneda = this.listaMoneda;
        dialog6.componentInstance.getTRM.subscribe(data => {
          this.getTRM.emit(data);
        });
        dialog6.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog6.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 7://Poseí activos omitidos originados en periodos no revisables sobre los cuales no se acogió a la Normalización Tributaria?
        let dialog7 = this.dialog.open(PatrimonioActivosOmitidosModalComponent, config);
        dialog7.componentInstance.listaMoneda = this.listaMoneda;
        dialog7.componentInstance.getTRM.subscribe(data => {
          this.getTRM.emit(data);
        });
        dialog7.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog7.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;

    }


  }

  protected validateModalCompleted(indexQuestion:number):boolean {
    let isModalComplete: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if ((this.model.doc.cuerpo[questions[indexQuestion].field] != undefined && this.model.doc.cuerpo[questions[indexQuestion].field] == "0") ||
          this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      isModalComplete = true;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }

  public validateComponentCompleted(): boolean {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].isCompleted == false) {
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      hasValues = true;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal: number) {
    switch (indexQuestionModal) {
      case 0://muebles
        this.model.doc.cuerpo.cc_id_181 = [];
        this.model.doc.cuerpo.cc_id_182 = [];
        this.model.doc.cuerpo.cc_id_183 = [];
        this.model.doc.cuerpo.cc_id_184 = [];
        this.model.doc.cuerpo.cc_id_185 = [];
        this.model.doc.cuerpo.cs_id_152 = "0";
        break;
      case 1://inmuebles
        this.model.doc.cuerpo.cc_id_190 = [];
        this.model.doc.cuerpo.cc_id_191 = [];
        this.model.doc.cuerpo.cc_id_192 = [];
        this.model.doc.cuerpo.cc_id_193 = [];
        this.model.doc.cuerpo.cc_id_194 = [];
        this.model.doc.cuerpo.cc_id_195 = [];
        this.model.doc.cuerpo.cc_id_196 = [];
        this.model.doc.cuerpo.cc_id_197 = [];
        this.model.doc.cuerpo.cc_id_198 = [];
        this.model.doc.cuerpo.cc_id_199 = [];
        this.model.doc.cuerpo.cc_id_200 = [];
        this.model.doc.cuerpo.cc_id_201 = [];
        this.model.doc.cuerpo.cs_id_154 = "0";//suma de valores
        break;
      case 2://acciones
        this.model.doc.cuerpo.cc_id_204 = [];
        this.model.doc.cuerpo.cc_id_205 = [];
        this.model.doc.cuerpo.cc_id_206 = [];
        this.model.doc.cuerpo.cc_id_207 = [];
        this.model.doc.cuerpo.cc_id_208 = [];
        this.model.doc.cuerpo.cc_id_209 = [];
        this.model.doc.cuerpo.cc_id_210 = [];
        this.model.doc.cuerpo.cc_id_211 = [];
        this.model.doc.cuerpo.cs_id_156 = "0";//suma valores de acciones
        break;
      case 3://cuentas en efectivo
        this.model.doc.cuerpo.cc_id_222 = [];
        this.model.doc.cuerpo.cc_id_223 = [];
        this.model.doc.cuerpo.cc_id_224 = [];
        this.model.doc.cuerpo.cc_id_225 = [];
        this.model.doc.cuerpo.cs_id_160 = "0";
        break;
      case 4://inventarios
        this.model.doc.cuerpo.cc_id_216 = [];
        this.model.doc.cuerpo.cc_id_217 = [];
        this.model.doc.cuerpo.cs_id_158 = "0";//suma valores de inventario
        break;
      case 5://otros activos
        this.model.doc.cuerpo.cc_id_228 = [];
        this.model.doc.cuerpo.cc_id_229 = [];
        this.model.doc.cuerpo.cc_id_230 = [];
        this.model.doc.cuerpo.cs_id_162 = "0";//suma valores de mda nacional
        break;
      case 6://activos moneda extranjera
        this.model.doc.cuerpo.cc_id_234 = [];
        this.model.doc.cuerpo.cc_id_235 = [];
        this.model.doc.cuerpo.cc_id_236 = [];
        this.model.doc.cuerpo.cc_id_237 = [];
        this.model.doc.cuerpo.cc_id_238 = [];
        this.model.doc.cuerpo.cc_id_239 = [];
        this.model.doc.cuerpo.cs_id_164 = "0"; //suma valores mda extranjera
        break;
      case 7://activos omitidos
        this.model.doc.cuerpo.cc_id_243 = [];
        this.model.doc.cuerpo.cc_id_244 = [];
        this.model.doc.cuerpo.cc_id_245 = [];
        this.model.doc.cuerpo.cc_id_246 = [];
        this.model.doc.cuerpo.cc_id_247 = [];
        this.model.doc.cuerpo.cc_id_248 = [];
        this.model.doc.cuerpo.cs_id_166 = "0"; //suma valores activos omitidos
        break;

    }
    this.dependenciaTarjetas(indexQuestionModal);
    this.saveModel.emit(true);

    //console.log(this.model);
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if (this.model.doc.cuerpo[data.field] == "0") {
      if (this.questionHasSugerida(index)) {
        const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
          data: {
            mensaje1: 'Usted tiene información sugerida para esta pregunta',
            mensaje2: 'Puede revisarla u omitirla para continuar con la siguiente pregunta.',
            botonTrue: 'Revisar',
            botonFalse: 'Omitir'
          }
        });
        dialogRef
          .afterClosed().subscribe(res => {

            if (res) { 
              this.model.doc.cuerpo[data.field] = "1";//restaura el radio button a Sí
              this.validateModalCompleted(index);
              this.saveModel.emit(true);
              this.openModal(index);
              questions[index].resp="1";
              return;//sale sin mostrar el segundo modal que pregunta si quiere eliminar los datos
            }else{
              this.validateModalCompleted(index);
            }
            this.askIfDeleteModalData(index, data);
            
          });
          
      }else{
        this.validateModalCompleted(index);
        this.askIfDeleteModalData(index, data);
      }
      
    } else if (this.model.doc.cuerpo[data.field] == "1") {
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrándolo completo
      this.openModal(index);
      this.saveModel.emit(true);
    }
    this.checkNextQuestion(index);
  }




  private askIfDeleteModalData(index: number, data: any) {
    if (this.validateHasModalValues(index)) {

      const dialogRef2 = this.dialog.open(DialogoConfirmacionComponent, {
        data: {
          mensaje1: '¿Está seguro de eliminar esta información?',
          mensaje2: 'Al hacerlo no podrá recuperarla.',
          botonTrue: 'Sí',
          botonFalse: 'No'
        }
      });
      dialogRef2
        .afterClosed().subscribe(result => {
          if (result) { //si desea eliminar el contenido del modal
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          } else { //no desea eliminar el contenido del modal
            questions[index].resp="1";
            this.model.doc.cuerpo[data.field] = "1";
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          }
        });
    } else {
      questions[index].isCompleted = true;
      this.cleanModalValues(index);
      this.saveModel.emit(true);
    }
  }
  dependenciaTarjetas(indexQuestionModal:number)
  {
    switch (indexQuestionModal) {
      case 0://¿Tuve bienes muebles? (vehículos, enseres de uso doméstico y otros). Incluya los adquiridos por leasing.
        break;
      case 1://¿Tuve bienes inmuebles? (casas, lotes, fincas, apartamentos, parcelas, parqueaderos, locales, oficinas y otros). Incluya los adquiridos por leasing.
        break;
      case 2://¿Tuve acciones o cuotas partes en sociedades?
        break;
      case 3://A diciembre 31 ¿Tuve ahorros en, dinero en efectivo, cuentas bancarias, depósitos de bajo monto (billeteras virtuales), CDTS, fondos de empleados, fondos de cesantías, fondos de pensiones voluntarias, cooperativas y otras entidades financieras?
        break;
      case 4://A diciembre 31 ¿Como persona natural tuve inventarios?
        break;
      case 5://A diciembre 31 ¿Tuve activos en moneda nacional diferentes de los anteriores?
      
        break;
      case 6://A diciembre 31 ¿Tuve activos en moneda extranjera?
        break;
      case 7://Poseí activos omitidos originados en periodos no revisables sobre los cuales no se acogió a la Normalización Tributaria?
          //Recalcular casillas 779, 780, 781, 783
          const rtasLiquidasGravablesComponent = this._componentFactory.createModalComponent(RentasLiquidasGravablesComponent, this.model);
          rtasLiquidasGravablesComponent.instance.initializeTablaDesdeModelo();
        break;

    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/patrimonio/patrimonio.component.ts